import React from 'react'
import { useApplicationStore } from 'hooks/application'
import { validateSourceUrl } from 'helpers/utils'
import { APP_URL } from 'app-constants'

const Powered: React.FC = () => {
  const { sidebarWidth } = useApplicationStore()

  return (
    <div
      className="flex items-center justify-center w-fit sm:w-[200px] overflow-x-auto fixed bottom-0 bg-surface z-[1] py-[15px] px-5 text-[90%] border-b-0 border-t-2 border-t-divider"
      style={{
        left: `${sidebarWidth}px`,
        minWidth: `calc(100vw - ${sidebarWidth}px)`
      }}
    >
      <b>Powered by</b>
      <a className="flex items-center justify-center" href="https://morta.io" target="_blank" rel="noopener noreferrer">
        <img
          className="ml-2.5 w-[100px] h-5"
          src={validateSourceUrl(`${APP_URL}/assets/images/morta.webp`)}
          alt="morta"
        />
      </a>
    </div>
  )
}

export default Powered
